import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormArray } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { OptionService } from 'src/app/options/option.service';
import { QRFeesCategory, QRfeesCategoryPrices } from './qrfeescategory.model';
import { QrfeescategoryService } from './qrfeescategory.service';
import { ThemePalette } from '@angular/material/core';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
  selector: 'app-qrfeescategory',
  templateUrl: './qrfeescategory.component.html',
  styleUrls: ['./qrfeescategory.component.css'],
  queries: {
    contentRef: new ViewChild("ModalCategory")
  },
})
export class QrfeescategoryComponent implements OnInit {

  categoryFeesForm!: FormGroup;
  public contentRef!: TemplateRef<any>;
  updateMode: boolean = false;
  categoryName!: string;
  categories: any;
  spinnerOverlay = false;
  feesCategory: QRFeesCategory = {} as QRFeesCategory;
  _QRFeesCategory: QRFeesCategory = {} as QRFeesCategory;
  _feesCategoryPrices: QRfeesCategoryPrices = {} as QRfeesCategoryPrices
  selectedCategory = 0;

  color: ThemePalette = 'primary';
  enableQrPercent = false;
  constructor(private dialog: MatDialog,
    private service: QrfeescategoryService,
    private snackBar: MatSnackBar,
    private optionService: OptionService,
    private translate: TranslateService) { }

  ngOnInit(): void {

    this.getSystemSettings();
    this.connectFormGroup();
    this.getCategories();
  }

  connectFormGroup() {

    let _feesAmount = new FormArray([]);

    this.categoryFeesForm = new FormGroup({

      catgId: new FormControl(null),
      feesAmounts: _feesAmount
    });

    this.addFeesAmountRows();
  }

  getFeesAmountControls() {
    return (<FormArray>this.categoryFeesForm.get('feesAmounts')).controls;
  }

  addFeesAmountRows() {

    for (let i = 0; i < 5; i++) {
      (<FormArray>this.categoryFeesForm.get('feesAmounts')).push(
        new FormGroup({
          id: new FormControl(0),
          fromAmount: new FormControl(this._feesCategoryPrices.fromAmount, [Validators.required]),
          toAmount: new FormControl(this._feesCategoryPrices.toAmount, [Validators.required]),
          fees: new FormControl(this._feesCategoryPrices.fees, [Validators.required]),
          percent: new FormControl(this._feesCategoryPrices.percent, [Validators.required])
        }))
    }
  }

  getCategories() {
    this.service.getAllCategory().subscribe(data => {
      this.categories = data;
    })
  }

  getByCategoryId() {
    const control = (<FormArray>this.categoryFeesForm.get('feesAmounts'));
    control.reset();
    this.service.getByCategory(this.categoryFeesForm.get("catgId")?.value).subscribe(data => {
      control.patchValue(data);
    })
  }

  addNewCategory() {
    this.openCategoryDialog()
  }

  saveCategory() {
    this.spinnerOverlay = true;
    var obj = {
      name: this.categoryName
    }
    this.service.CreateCategory(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.dialog.closeAll();
      this.getCategories();
      this.spinnerOverlay = false;

    })
  }

  catgSelectChange() {
    this.selectedCategory = this.categoryFeesForm.get("catgId")?.value;
    this.getByCategoryId()
  }

  onNoClick() {
    this.dialog.closeAll();
  }

  openCategoryDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openSnackBar(message: any, cssclass: any) {
    this.snackBar.open(message, 'X', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass

    });
  }

  saveForm() {

    this.spinnerOverlay = true;
    var obj = {
      catgId: this.categoryFeesForm.get("catgId")?.value,
      feesAmounts: this.categoryFeesForm.get("feesAmounts")?.value
    }


    this._QRFeesCategory = obj;
    console.log(obj)
    this.service.saveCategoryPrices(obj).subscribe(data => {
      this.spinnerOverlay = false;
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
    })
  }

  setAsDefault() {
    this.updateSystemSettings();
  }


  updateSystemSettings() {
    this.spinnerOverlay = true;
    var obj = {
      "key": "Default_qrFees_Category",
      "value": this.categoryFeesForm.get('catgId')?.value
    }

    this.optionService.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        console.log(error);
      })
  }

  getSystemSettings() {

    this.optionService.getSystemSettings("Use_QR_Percent").subscribe(data => {
      this.enableQrPercent = JSON.parse(data["value"]);
    },
      error => {
        console.log(error);
      });
  }

  EnableQrPercent(event: MatSlideToggleChange) {
    this.enableQrPercent = event.checked
    this.spinnerOverlay = true;
    var obj = {
      "key": "Use_QR_Percent",
      "value": this.enableQrPercent ? true : false
    }

    this.optionService.updateSystemSettings(obj).subscribe(data => {
      this.openSnackBar(this.translate.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

}
